import { c as _c } from "react/compiler-runtime";
import React from "react";
import ValidationError from "../submission/ui/ValidationError";
import { CheckCircleIcon } from "@heroicons/react/24/outline";
interface TraitWrapperProps {
  readonly label: string;
  readonly readOnly?: boolean | undefined;
  readonly children: React.ReactNode;
  readonly isBoolean?: boolean | undefined;
  readonly className?: string | undefined;
  readonly error?: string | null | undefined;
  readonly id?: string | undefined;
  readonly isFieldFilled?: boolean | undefined;
}
export const TraitWrapper: React.FC<TraitWrapperProps> = t0 => {
  const $ = _c(43);
  const {
    label,
    readOnly: t1,
    children,
    isBoolean: t2,
    className,
    error,
    id,
    isFieldFilled: t3
  } = t0;
  const readOnly = t1 === undefined ? false : t1;
  const isBoolean = t2 === undefined ? false : t2;
  const isFieldFilled = t3 === undefined ? false : t3;
  let t4;
  if ($[0] !== id || $[1] !== label) {
    t4 = id ?? `field-${label.toLowerCase().replace(/\s+/g, "-")}`;
    $[0] = id;
    $[1] = label;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const fieldId = t4;
  const errorId = error ? `${fieldId}-error` : undefined;
  const hasError = !!error && !readOnly;
  let labelClassName = "tw-text-iron-300 group-focus-visible-within:tw-text-primary-400";
  if (readOnly) {
    labelClassName = "tw-text-iron-500";
  } else {
    if (hasError) {
      labelClassName = "tw-text-red-400";
    }
  }
  if (isBoolean) {
    const t5 = `tw-group tw-relative ${className ?? ""}`;
    let t6;
    if ($[3] !== fieldId || $[4] !== label) {
      t6 = <label htmlFor={fieldId} className="tw-text-sm tw-font-medium tw-text-iron-300 tw-cursor-pointer tw-w-40 tw-flex-shrink-0">{label}</label>;
      $[3] = fieldId;
      $[4] = label;
      $[5] = t6;
    } else {
      t6 = $[5];
    }
    let t7;
    if ($[6] !== children) {
      t7 = <div className="tw-flex-1 tw-max-w-xs">{children}</div>;
      $[6] = children;
      $[7] = t7;
    } else {
      t7 = $[7];
    }
    let t8;
    if ($[8] !== t6 || $[9] !== t7) {
      t8 = <div className="tw-flex tw-items-center tw-justify-between tw-gap-4">{t6}{t7}</div>;
      $[8] = t6;
      $[9] = t7;
      $[10] = t8;
    } else {
      t8 = $[10];
    }
    let t9;
    if ($[11] !== t5 || $[12] !== t8) {
      t9 = <div className={t5}>{t8}</div>;
      $[11] = t5;
      $[12] = t8;
      $[13] = t9;
    } else {
      t9 = $[13];
    }
    return t9;
  }
  const t5 = `tw-group tw-relative tw-pb-8 ${className ?? ""}`;
  const t6 = `tw-absolute tw-left-3 -tw-top-2 tw-px-1 tw-text-xs tw-font-medium tw-bg-iron-900 tw-z-10 tw-transition-all ${labelClassName}`;
  let t7;
  if ($[14] !== fieldId || $[15] !== label || $[16] !== t6) {
    t7 = <label htmlFor={fieldId} className={t6}>{label}</label>;
    $[14] = fieldId;
    $[15] = label;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== children || $[19] !== errorId || $[20] !== fieldId || $[21] !== hasError) {
    let t9;
    if ($[23] !== errorId || $[24] !== fieldId || $[25] !== hasError) {
      t9 = child => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, {
            id: fieldId,
            "aria-invalid": hasError,
            "aria-describedby": errorId,
            ...(child.props || {})
          } as any);
        }
        return child;
      };
      $[23] = errorId;
      $[24] = fieldId;
      $[25] = hasError;
      $[26] = t9;
    } else {
      t9 = $[26];
    }
    t8 = React.Children.map(children, t9);
    $[18] = children;
    $[19] = errorId;
    $[20] = fieldId;
    $[21] = hasError;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[27] !== hasError || $[28] !== isFieldFilled) {
    t9 = isFieldFilled && !hasError && <div className="tw-absolute tw-right-3 tw-top-1/2 tw-transform -tw-translate-y-1/2 tw-pointer-events-none"><CheckCircleIcon className="tw-text-emerald-500 tw-w-5 tw-h-5 tw-flex-shrink-0" /></div>;
    $[27] = hasError;
    $[28] = isFieldFilled;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== t8 || $[31] !== t9) {
    t10 = <div className="tw-relative tw-rounded-xl tw-bg-iron-950 tw-transition-all tw-duration-200">{t8}{t9}</div>;
    $[30] = t8;
    $[31] = t9;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] !== t10 || $[34] !== t7) {
    t11 = <div className="tw-relative">{t7}{t10}</div>;
    $[33] = t10;
    $[34] = t7;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  let t12;
  if ($[36] !== error || $[37] !== errorId) {
    t12 = <div className="tw-absolute tw-left-0 tw-right-0 tw-bottom-0"><ValidationError error={error} id={errorId} className="tw-mt-0" /></div>;
    $[36] = error;
    $[37] = errorId;
    $[38] = t12;
  } else {
    t12 = $[38];
  }
  let t13;
  if ($[39] !== t11 || $[40] !== t12 || $[41] !== t5) {
    t13 = <div className={t5}>{t11}{t12}</div>;
    $[39] = t11;
    $[40] = t12;
    $[41] = t5;
    $[42] = t13;
  } else {
    t13 = $[42];
  }
  return t13;
};